import mqtt from 'mqtt';
import { isJSONString } from '@/utils/utils';
export default class MqttWireless {
  static client = null; // (window as any).mqttClient;

  /** 当前应用mqtt是否已经存在的唯一标识 */
  static clientIdWireless = '';
  //订阅的主题
  static subscribeTopicsWireless = [];
  //各主题的回调函数
  static subscribeTopicCallbackWireless = {};
  //是否连接
  static isWirelessConnected = false;

  static async create(triggerFun, callBack) {
    try {
      // 1. 获取凭证
      const userData = localStorage.getItem('mqtt_saveUser') ? JSON.parse(localStorage.getItem('mqtt_saveUser')) : {};
      const username = userData?.username;//获取存储的登录用户名
      const passwordSave = userData?.password;//获取存储的登录密码（明文形式）
      const user_id = userData?.data?.user_id || '';//获取存储的用户id，用于mqtt连接时生成clientId
      const wssAddress = location.host.indexOf('localhost') > -1 ? 'wss://merge-wss.sk-robot.com:18883/mqtt' : location.host.indexOf('warranty-us') > -1 ? 'wss://prod-us-wss.sk-robot.com:18883/mqtt' : 'wss://prod-eu-wss.sk-robot.com:18883/mqtt';
      if (!user_id) {
        return;
      }
      console.log('开始连接', MqttWireless);
      if (MqttWireless.clientWireless) {
        // 清除旧的监听器
        MqttWireless.clientWireless.removeAllListeners();
      }
      if (!MqttWireless.clientIdWireless) {
        //如果存在旧的mqttClient，则先断开连接
        if (window.mqttClientWireless) {
          window.mqttClientWireless.connected &&
            window.mqttClientWireless.end(true);
          window.mqttClientWireless = null;
        }
        // 生成新的clientId
        MqttWireless.clientIdWireless = `APP:APP_${user_id}_${Date.now()}wireless`;
        // 生成新的mqttClient
        MqttWireless.clientWireless = mqtt.connect(
          process.env.NODE_ENV === 'development'
            ? `wss://merge-wss.sk-robot.com:18883/mqtt`
            : wssAddress,
          {
            clean: true, // 保留回话
            connectTimeout: 30 * 100, // 超时时间
            // 认证信息
            clientId: MqttWireless.clientIdWireless, // 连接mqtt的客户端id
            username: username,// 连接mqtt的用户名
            password: passwordSave, // 连接mqtt的密码
            reconnectPeriod: 15000
          }
        );
        window.mqttClientWireless = MqttWireless.clientWireless;
      }

      //连接mqtt
      MqttWireless.clientWireless.on('connect', function () {
        console.log('握手成功', MqttWireless.clientIdWireless);
        MqttWireless.isWirelessConnected = true; // 记录连接成功的标识
      });
      //mqtt收到上报消息，调用各注册回调函数传输获取到的消息
      MqttWireless.clientWireless.on('message', function (topic, message, packet) {
        const payload = { topic, message: message.toString() };
        //isJSONString用于判断是否为可parse的JSON字符串
        if (isJSONString(payload.message)) {
          //判断topic是否在订阅列表中,如果在则调用回调
          if (MqttWireless.subscribeTopicCallbackWireless[topic]) {
            MqttWireless.subscribeTopicCallbackWireless[topic] &&
              MqttWireless.subscribeTopicCallbackWireless[topic](payload.message);
          }
          console.log(
            '收到推送无线',
            topic,
            message,
            payload,
            JSON.parse(payload.message)
          );
        } else {
          //非标准格式的消息，直接调用回调函数
          if (MqttWireless.subscribeTopicCallbackWireless[topic]) {
            MqttWireless.subscribeTopicCallbackWireless[topic] &&
              MqttWireless.subscribeTopicCallbackWireless[topic](payload.message);
          }
        }
        // const msg = JSON.parse(Utf8ArrayToStr(message));
        const msg = message;
        callBack(msg);
      });

      //重新连接后重新订阅
      MqttWireless.clientWireless.on('reconnect', function () {
        console.log('重新连接', MqttWireless.clientWireless?.connected);
        //根据存储的订阅topic列表，在reconnect之后重新订阅
        if (
          MqttWireless.subscribeTopicsWireless.length > 0 &&
          MqttWireless.clientWireless &&
          MqttWireless.clientWireless.connected
        ) {
          try {
            MqttWireless.subscribeTopicsWireless.forEach(item => {
              MqttWireless?.clientWireless?.subscribe(item.topic, item.qos);
            });
          } catch (error) {
            console.log('error', error);
          }
        }
      });

      MqttWireless.clientWireless.on('end', function () {
        console.log('握手关闭触发');
        //TODO: 关闭之后清除订阅信息及window挂载字段
        if (window.mqttClientWireless) {
          window.mqttClientWireless.connected &&
            window.mqttClientWireless.end(true);
          window.mqttClientWireless = null;
        }
        MqttWireless.clientIdWireless = '';
        MqttWireless.clientWireless = null;
        MqttWireless.subscribeTopicsWireless = [];
        MqttWireless.subscribeTopicCallbackWireless = {};
      });
      // 连接断开，重置连接标识为false
      MqttWireless.clientWireless.on('close', function () {
        console.log('握手close');
        MqttWireless.isWirelessConnected = false;
      });
      // mqtt发生错误后断开连接
      MqttWireless.clientWireless.on('error', function (error) {
        console.log('握手失败', error);
        if (MqttWireless.clientWireless) {
          MqttWireless.clientWireless.end();
        }
      });
      // mqtt的log
      MqttWireless.clientWireless.on('log', (level, message) => {
        console.log('MQTT日志:', message);
      });
    } catch (error) {
      console.error('MQTT连接初始化失败:', error)
    }
  }
  //关闭mqtt连接
  static end() {
    if (MqttWireless.clientWireless) {
      console.log('发起关闭');
      MqttWireless.clientWireless.end();
    }
  }
  //发送消息
  static send(topic, msg, qos) {
    msg = JSON.stringify(msg);
    if (MqttWireless.clientWireless) {
      MqttWireless.clientWireless.publish(
        topic,
        msg,
        { qos: qos || 0 },
        err => {
          if (err) {
            console.log('err message publish', err);
          }
        }
      );
    }
  }
  //解除订阅
  static unSubscribe(topic, qos) {
    if (MqttWireless.clientWireless) {
      // unsubscribe topic
      console.log('unsubscribe topic wireless:', topic);
      if (MqttWireless.subscribeTopicsWireless.indexOf(topic) > -1) {
        //删除回调函数
        delete MqttWireless.subscribeTopicCallbackWireless[topic];
        MqttWireless.subscribeTopicsWireless.splice(
          MqttWireless.subscribeTopicsWireless.indexOf(topic),
          1
        );
        MqttWireless.clientWireless?.unsubscribe(
          topic,
          { qos: qos || 0 },
          error => {
            if (error) {
              console.log('Unsubscribe error', error);
              return;
            }
            console.log(`unsubscribed topic: ${topic}`);
          }
        );
      }
    }
  }
  //订阅mqtt主题，并保存回调函数
  static subscribe(topic, qos, callBack) {
    if (MqttWireless.clientWireless) {
      // subscribe topic
      console.log('subscribe topic wireless:', topic);
      if (MqttWireless.subscribeTopicsWireless.indexOf(topic) === -1) {
        MqttWireless.subscribeTopicsWireless.push(topic);
        if (callBack) {
          MqttWireless.subscribeTopicCallbackWireless[topic] = callBack;
        }
        MqttWireless.clientWireless?.subscribe(
          topic,
          { qos: qos || 0 },
          error => {
            if (error) {
              console.log('Subscribe to topics error', error);
              return;
            }
            console.log(`Subscribe to topics: ${topic}`);
          }
        );
      }
    }
  }
  //publish mqtt主题
  static publish(pubRecord) {
    if (MqttWireless.clientWireless) {
      const { topic, qos, payload } = pubRecord;
      MqttWireless.clientWireless.publish(topic, payload, { qos }, error => {
        if (error) {
          console.log('Publish error: ', error);
        }
      });
    }
  }
  //mqtt重连机制
  static reconnect() {
    return new Promise((resolve, reject) => {
      if (MqttWireless.clientWireless) {
        MqttWireless.clientWireless.end(true, {}, () => {
          MqttWireless.clientWireless.reconnect();
          resolve();
        });
      }
    });
  }
}